exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content{display:block;padding-top:5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/login/styles.styl
// module id = 948
// module chunks = 0